<div class="list-container">
    <dynamic-table [props]="props" class="dynamic-table d-flex flex-column">
        <ng-container *ngFor="let asset of assets">
            <div *ngIf="asset" 
                class="asset-table-row info-cell ccc ccc-hover cursor-pointer" 
                (click)="navigateToDetailHandler(asset.assetId)">
                <div class="info-container d-flex p-3">
                    <div class="col-lg-3 d-flex flex-column gap-1">
                        <div HJSuppress>
                            <div class="manufacturer text-primary">{{asset.assetName}}</div>
                            <div class="vin">
                                {{'asset.VIN' | translate}}:
                                <b>{{asset.vin}}</b>
                            </div>
                        </div>
                        <div class="d-flex" *ngIf="asset.issuesNumber > 0">
                            <div class="badge custom-badge warning">{{asset.issuesNumber}} {{'assetFleetManagement.listView.issues' | translate}}</div>
                        </div>
                    </div>
                    <div class="col-lg-9 d-flex flex-column gap-4">
                        <div class="details-grid-container ">
                            <div class="column-content" *ngIf="asset.driverName">
                                <div class="cell-title">{{'assetFleetManagement.listView.driverName' | translate}}</div>
                                <div HJSuppress class="d-flex gap-1" >
                                    <span class="link-underline-primary-custom">{{ asset.driverName }} </span>
                                    <i class="app-icon icon icon-arrow-up icon-md custom-icon text-primary"></i>
                                    <div class="badge custom-badge ms-1" 
                                        [ngClass]="[asset.driverClass === 'A'?'success':'info']">{{asset.driverClass}}
                                    </div>
                                </div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'asset.RegistrationNumber' | translate}}</div>
                                <div HJSuppress class="cell-value">{{asset.registrationNumber || '-'}}</div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetFleetManagement.listView.warranty' | translate}}</div>
                                <div HJSuppress class="cell-value">{{'assetFleetManagement.listView.until' | translate}} {{asset.warrantyDate | localizedDate}}</div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetFleetManagement.listView.status' | translate}}</div>
                                <span HJSuppress class="badge custom-badge gap-2 align-items-center">
                                  <span class="dot" 
                                        [ngClass]="{'assigned': asset.status === 'Assigned',
                                            'unassigned': asset.status === 'Unassigned',
                                            'in-progress': asset.status === 'In Workshop'}">
                                    </span>{{asset.status}}
                                </span>
                            </div>
                            <div class="column-content" >
                                <div class="cell-title">{{'assetFleetManagement.listView.mileage' | translate }}</div>
                                <div HJSuppress class="cell-value">{{asset.mileage | number: '1.0'}} {{'assetFleetManagement.listView.mileageLabel' | translate }}</div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetFleetManagement.listView.contract' | translate}}</div>
                                <div HJSuppress class="link-underline-primary-custom">{{asset.contract}}
                                    <i class="app-icon icon icon-arrow-up icon-md custom-icon ms-1"></i>
                                </div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetFleetManagement.listView.services' | translate}}</div>
                                <div HJSuppress class="cell-value">{{asset.contractItemServices.length}}</div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetFleetManagement.listView.fuelConsumtions' | translate}}</div>
                                <div HJSuppress class="cell-value">
                                    {{asset.fuelConsumtions}}<span class="mx-1">l</span>/ {{'assetFleetManagement.listView.fuelConsumtionsLabel' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="buttons-container p-3">
                    <div class="d-flex justify-content-end gap-3">
                        <button 
                            *ngIf="asset.driverName"
                            class="btn white-btn custom-btn" 
                            (click)="openDelegateModal($event, asset)">
                            <i class="app-icon icon icon-reload icon-lg me-2 text-primary"></i> 
                            {{'assetFleetManagement.listView.changeDrivers' | translate}} 
                        </button>
                        <button 
                            *ngIf="!asset.driverName"
                            class="btn white-btn custom-btn" 
                            (click)="openDelegateModal($event, asset)">
                            <i class="app-icon icon icon-add icon-lg me-2 text-primary"></i> 
                            {{'assetFleetManagement.listView.addDriver' | translate}} 
                        </button>
                        <button 
                            class="btn btn-primary text-light" 
                            (click)="redirectDocumentRequest($event, asset.contractExternalEntityId, asset.assetId)">
                            {{'contractDetail.assets.documentRequest' | translate}} 
                        </button>
                    </div>
                </div>
                <div *ngIf="asset.issuesNumber"
                    class="circle-box-border1 circle-box-border1-red notify-dot">
                </div>
            </div>
        </ng-container>
    </dynamic-table>
</div>

